﻿import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import ILog from '../../shared/interfaces/ILog';
import DateTimeView from '../../features/localDate/DateTimeView';

const LogsList = ({ logs, userHeader }: { logs: ILog[], userHeader: string }) => {
    function displayImpersonationInfo(log: ILog) {
        if (log.impersonating_Username_Snapshot) {
            return (
                <i
                    className="material-icons"
                    title={`Impersonated by ${log.impersonating_Username_Snapshot}`}
                >
                    people_outline
                </i>
            );
        }
        return null;
    }

    return (
        <Table hover>
            <thead>
                <tr>
                    <th> @</th>
                    <th>{Translate('logs/list/header/user')}</th>
                    <th>{Translate('logs/list/header/event-log-code')}</th>
                    <th>{Translate('logs/list/header/log')}</th>
                    <th>{userHeader ? userHeader : Translate('logs/list/header/photographer')}</th>
                </tr>
            </thead>
            <tbody>
                {logs.map((log: ILog) => {
                    return (
                        <tr key={log.id}>
                            <td>{<DateTimeView dateTime={log.timestamp}></DateTimeView>}</td>
                            <td>
                                {log.actor_Username_Snapshot} {displayImpersonationInfo(log)}
                            </td>
                            <td>{log.eventLogCode}</td>
                            <td>{log.text}</td>
                            <td>{log.photographer_Name_Snapshot}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default LogsList;
